import { Box } from '@chakra-ui/react';
import { RenderSections } from '@eternal/Common/RenderSections';
import Header from '@eternal/Components/Header';

/**
 *
 * @param {Object} pageBody
 * @returns
 */
const EternalUi = ({ pageBody, region, lang }) => {
  // console.log(pageBody, 'page Data');
  return (
    <Box as="section" className="btn-center" pos="relative">
      <Header zIndex="1000" position="absolute" top="0" />
      {pageBody && pageBody.length
        ? pageBody?.map((section, i) => {
            return (
              <RenderSections
                section={section}
                region={region}
                lang={lang}
                pType="health"
                key={i}
              />
            );
          })
        : null}
    </Box>
  );
};

export default EternalUi;
